import React from 'react';

import Button from '../../library/button/button';
import Image from '../../library/image/image';
import { InputError } from '../../library/input/input-types';
import Text from '../../library/text/text';
import Typography from '../../library/typography/typography';

import './treadwell-zip-code-input.scss';

interface TreadwellZipCodeInputProps {
  city?: string;
  error: InputError;
  isValid: boolean;
  onBlur?: () => void;
  onChange: () => void;
  onFocus?: () => void;
  onKeyPress: () => void;
  onSubmit?: () => void;
  primaryCTAText?: string;
  showCityInfo?: boolean;
  showSubmitButton?: boolean;
  state?: string;
  value: string;
}

function TreadwellZipCodeInput(props: TreadwellZipCodeInputProps) {
  const {
    city,
    error,
    isValid,
    onBlur,
    onChange,
    onFocus,
    onKeyPress,
    onSubmit,
    primaryCTAText = 'Continue',
    showCityInfo = false,
    showSubmitButton = false,
    state,
    value
  } = props;

  return (
    <div className="treadwell-zip-code-input" styleName="zip-content-wrapper">
      <div styleName="messaging">
        <Typography styleName="prompt" tag="span" variant="h4">
          <Image
            alt="Treadwell icon"
            height="26"
            src="https://discounttire.scene7.com/is/content/discounttire/logos/treadwell-icon-only-trademark.svg"
            styleName="icon"
          />
          Where do you drive<strong>&nbsp;most?</strong>
        </Typography>

        <Typography tag="span">
          Enter your Zip code so Treadwell can match you with the best tires for
          the weather and roads where you live.
        </Typography>
      </div>

      <div
        className="treadwell-zip-code-input__form-container"
        styleName={`form-container ${showSubmitButton ? '' : 'no-button'}`}
      >
        <Text
          autoComplete="postal-code"
          error={error}
          isRequired
          label="Zip Code"
          onBlur={onBlur}
          onChange={onChange}
          onFocus={onFocus}
          onKeyPress={onKeyPress}
          value={value}
        />

        {showCityInfo && (
          <div styleName="city-container">
            <div>{value}</div>
            <div>
              <span styleName="city">{city?.toLowerCase()}</span>, {state}
            </div>
          </div>
        )}

        {showSubmitButton && (
          <Button
            className="treadwell-zip-code-input__continue-button"
            isDisabled={!isValid}
            isPrimary
            onClick={() => {
              onSubmit?.();
            }}
            styleName="continue-button"
          >
            {primaryCTAText}
          </Button>
        )}
      </div>
    </div>
  );
}

export default TreadwellZipCodeInput;
